import React from 'react';
import { Row, Col, ControlLabel, Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import ImageFallback from '../../common/imageFallback/ImageFallback';

import './Details.css';

const I18n = require('i18n-react').default;

const propTypes = {
  id: PropTypes.string.isRequired,
  close: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  flights: PropTypes.arrayOf(
    PropTypes.shape({
      flightNumber: PropTypes.number.isRequired,
      origin: PropTypes.string.isRequired,
      originAirportName: PropTypes.string.isRequired,
      destination: PropTypes.string.isRequired,
      destinationAirportName: PropTypes.string.isRequired,
      departureTime: PropTypes.string.isRequired,
      arrivalTime: PropTypes.string.isRequired,
      dateVariation: PropTypes.number,
      marketingCarrier: PropTypes.string.isRequired,
      operatingCarrier: PropTypes.string.isRequired,
      throughFlight: PropTypes.bool,
      hasExchangeAirport: PropTypes.bool
    })
  )
};

const defaultProps = {
  flights: []
};

class Details extends React.Component {
  formatDateVariation(flight) {
    const dateVariation = flight.dateVariation;
    let formatDateVariation = '';
    if (dateVariation && dateVariation > 0) {
      formatDateVariation = `+${dateVariation} ${I18n.translate(`components.modalDetails.day`)}`;
      if (dateVariation > 1) {
        formatDateVariation = `+${dateVariation} ${I18n.translate(`components.modalDetails.days`)}`;
      }
    }
    return formatDateVariation;
  }

  renderAirportChange(flight) {
    if (flight.hasExchangeAirport) {
      return (
        <Row className="Details__colAirportChange">
          <Col xs={12}>
            <i className="Details__iconAirportChange">
              <ControlLabel className="Details__airportChange">
                {I18n.translate('components.modalDetails.airportChange')}
              </ControlLabel>
            </i>
          </Col>
        </Row>
      );
    }
  }

  renderFlights() {
    const flights = this.props.flights;
    if (flights.length > 0) {
      return flights.map(flight => {
        return (
          <div
            key={`${this.props.id}-item-${flight.flightNumber}${
              flight.throughFlight ? '-throughFlight' : ''
            }`}
            id={`${this.props.id}-item-${flight.flightNumber}${
              flight.throughFlight ? '-throughFlight' : ''
            }`}>
            <Row>
              <Col xs={4}>
                <ControlLabel className="Details__flightInfo">
                  {`${I18n.translate('components.modalDetails.flight')} ${
                    flight.operatingCarrier
                  } ${flight.flightNumber}`}
                </ControlLabel>
              </Col>
              <Col xs={8} className="text-right">
                <ControlLabel className="Details__labelOperatingCarrier">
                  {I18n.translate('components.modalDetails.operatingCarrier')}
                </ControlLabel>
                <ImageFallback
                  className="Details__iconOperatingCarrier"
                  src={`styles/img/imgOperadoPor${flight.operatingCarrier}.png`}
                  alt={flight.operatingCarrier}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <ControlLabel className="Details__flightLocation">
                  {`${flight.originAirportName} (${flight.origin})`}
                </ControlLabel>
                <ControlLabel className="Details__labelFrom">
                  &nbsp;
                  {`${I18n.translate('components.modalDetails.from')}`}
                  &nbsp;
                </ControlLabel>
                <ControlLabel className="Details__flightLocation">
                  {`${flight.destinationAirportName} (${flight.destination})`}
                </ControlLabel>
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <ControlLabel className="Details__flightTime">{flight.departureTime}</ControlLabel>
                <div className="Details--iconArrow" />
                <ControlLabel className="Details__flightTime">{flight.arrivalTime}</ControlLabel>
                <ControlLabel className="Details__plusDays">
                  {this.formatDateVariation(flight)}
                </ControlLabel>
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <ControlLabel className="Details__titleObservation">
                  {I18n.translate('components.modalDetails.titlePunctuality')}
                </ControlLabel>
                <ControlLabel className="Details__observation">
                  {I18n.translate('components.modalDetails.messagePunctuality')}
                </ControlLabel>
              </Col>
            </Row>
            {this.renderAirportChange(flight)}
            <Row>
              <Col xs={12}>
                <div className="Details__line" />
              </Col>
            </Row>
          </div>
        );
      });
    }
  }

  render() {
    return (
      <Modal
        id={`componentModalDetails-${this.props.id}`}
        className="ModalDetail Details"
        ref={c => (this.modalDetails = c)}
        show={this.props.show}
        onHide={this.props.close}>
        <Modal.Header closeButton bsClass="ModalDetail__header">
          <Modal.Title>{I18n.translate('components.modalDetails.detailConnection')}</Modal.Title>
        </Modal.Header>

        <Modal.Body bsClass="ModalDetail__body">
          {this.renderFlights()}
          <Row>
            <Col xs={12}>
              <ControlLabel className="Details__generalObservation">
                {I18n.translate('components.modalDetails.messageExplainPunctuality')}
              </ControlLabel>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    );
  }
}

Details.propTypes = propTypes;
Details.defaultProps = defaultProps;

export default Details;



// WEBPACK FOOTER //
// ./src/components/flightSelection/details/Details.jsx